import React from "react";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("UI boundary caught an error", {
        boundary: this.props.boundaryName || "Application",
        error,
        componentStack: info?.componentStack,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.hasError &&
      prevProps.resetKey !== this.props.resetKey
    ) {
      this.setState({ hasError: false });
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.assign("/");
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <section className="error-boundary" role="alert">
        <div className="error-boundary__content">
          <h1>The page could not be displayed</h1>
          <p>Reload the page. If the problem continues, return home and try again later.</p>
          <div className="error-boundary__actions">
            <button type="button" onClick={this.handleReload}>
              Reload
            </button>
            <button type="button" onClick={this.handleHome}>
              Home
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export default ErrorBoundary;
